/* ORGAINIC Sortenschmuck: Deko-Teile fliegen beim Sortenwechsel einzeln aufs Hauptbild (Daten: flavor-deko-data.js) */
(function () {
  var atlasLoads = {};

  function loadAtlas(url) {
    if (!atlasLoads[url]) {
      atlasLoads[url] = new Promise(function (resolve) {
        var img = new Image();
        // nur onload: decode() hängt in Hintergrund-Tabs
        img.onload = img.onerror = resolve;
        img.src = url;
      });
    }
    return atlasLoads[url];
  }

  function setup(overlay) {
    if (overlay.flavorOverlay) return overlay.flavorOverlay;

    var config = JSON.parse(overlay.querySelector('[data-flavor-overlay-config]').textContent);
    // exakt über das Bild legen, nicht über den ganzen Slide
    var slide = overlay.closest('.slide');
    var wrapper = slide && slide.querySelector('.product-media--image .rimage-wrapper');
    if (wrapper) wrapper.appendChild(overlay);

    var state = { config: config, layers: {}, current: '', token: 0 };

    state.keyFor = function (variantId) {
      return config.variants[String(variantId)] || '';
    };

    state.layer = function (key) {
      if (state.layers[key]) return state.layers[key];
      var deko = (window.flavorDekoData || {})[key];
      if (!deko || !config.atlas[key]) return null;
      var layer = document.createElement('div');
      layer.className = 'flavor-overlay__layer';
      // burst: Deko liegt unter dem Beutel und wächst aus der Mitte, die Maske versteckt alles hinter dem Beutel
      var burst = deko.m === 'burst';
      if (burst) {
        layer.classList.add('is-burst');
        if (config.mask && config.mask[key]) layer.style.setProperty('--mask', 'url("' + config.mask[key] + '")');
      }
      deko.p.forEach(function (p) {
        var el = document.createElement('span');
        el.className = 'flavor-overlay__piece';
        el.style.cssText = 'left:' + p.l + '%;top:' + p.t + '%;width:' + p.w + '%;height:' + p.h + '%;' +
          'background-image:url("' + config.atlas[key] + '");' +
          'background-size:' + p.bs[0] + '% ' + p.bs[1] + '%;' +
          'background-position:' + p.bp[0] + '% ' + p.bp[1] + '%;' +
          (burst ? '--ox:' + p.ox + '%;--oy:' + p.oy + '%;' : '--dx:' + p.dx + '%;--dy:' + p.dy + '%;') +
          '--r:' + p.r + 'deg;--d:' + p.d + 'ms';
        layer.appendChild(el);
      });
      overlay.appendChild(layer);
      state.layers[key] = layer;
      return layer;
    };

    state.show = function (key, animate) {
      if (key === state.current) return;
      var old = state.current && state.layers[state.current];
      if (old) {
        old.classList.remove('is-active', 'no-anim');
        old.classList.add('is-leaving');
      }
      state.current = key;
      var token = ++state.token;
      if (!key || !config.atlas[key]) return;
      loadAtlas(config.atlas[key]).then(function () {
        if (token !== state.token) return;
        var layer = state.layer(key);
        if (!layer) return;
        layer.classList.remove('is-leaving', 'is-active');
        layer.classList.toggle('no-anim', !animate);
        void layer.offsetWidth;
        layer.classList.add('is-active');
      });
    };

    overlay.flavorOverlay = state;
    return state;
  }

  function init() {
    var overlays = document.querySelectorAll('[data-flavor-overlay]');
    if (!overlays.length) return;

    overlays.forEach(function (overlay) {
      var state = setup(overlay);
      var detail = overlay.closest('.product-detail');
      var select = detail && (detail.querySelector('custom-variant-selector [data-cvs-dropdown][data-box="1"] [data-cvs-value]') ||
        detail.querySelector('select.original-selector[name="id"]') || detail.querySelector('[name="id"]'));
      if (select && select.value) state.show(state.keyFor(select.value), false);
    });

    if (window.jQuery) {
      window.jQuery(document).on('variantImageSelected', '.gallery', function (e, variant, isFirstRun) {
        var overlay = this.querySelector('[data-flavor-overlay]');
        if (!overlay || !variant) return;
        var state = setup(overlay);
        // Sortenbild ist in der Galerie ausgeblendet (nur Warenkorb-Vorschau): aufs erste Bild mit der Deko springen
        var hidden = ',' + (state.config.hidden || '');
        if (!isFirstRun && variant.featured_media && hidden.indexOf(',' + variant.featured_media.id + ',') !== -1) {
          var $gallery = window.jQuery(this);
          var $first = $gallery.find('.thumbnails a.thumbnail:first');
          if ($first.length) {
            $first.trigger('select');
          } else {
            $gallery.find('.slideshow.slick-slider').slick('slickGoTo', 0);
          }
        }
        state.show(state.keyFor(variant.id), !isFirstRun);
      });
      // Produkte ohne Variantenbilder (z.B. Milchprotein) lösen kein variantImageSelected aus
      window.jQuery(window).on('cc-variant-updated', function (e, data) {
        if (!data || !data.variant || !data.product) return;
        overlays.forEach(function (overlay) {
          var state = setup(overlay);
          if (String(state.config.product) === String(data.product.id)) {
            state.show(state.keyFor(data.variant.id), true);
          }
        });
      });
    }

    // Mengenrabatt-Selector (LPs): eigenes Event je Packung, die zuletzt gewählte Sorte wird gezeigt
    var overlayFor = function (el) {
      var detail = el.closest('.product-detail');
      return detail && detail.querySelector('[data-flavor-overlay]');
    };
    document.addEventListener('cvs:variant-change', function (e) {
      var overlay = overlayFor(e.target);
      if (!overlay || !e.detail) return;
      overlay.cvsBox = parseInt(e.detail.box, 10) || 1;
      var state = setup(overlay);
      state.show(state.keyFor(e.detail.variantId), true);
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('input[name^="cvs_quantity_"]')) return;
      var cvs = e.target.closest('custom-variant-selector');
      var overlay = cvs && overlayFor(cvs);
      if (!overlay) return;
      // ist die zuletzt gewählte Packung jetzt ausgeblendet, auf die letzte sichtbare zurückfallen
      var box = Math.min(overlay.cvsBox || 1, parseInt(e.target.value, 10) || 1);
      var hidden = cvs.querySelector('[data-cvs-dropdown][data-box="' + box + '"] [data-cvs-value]');
      if (!hidden) return;
      var state = setup(overlay);
      state.show(state.keyFor(hidden.value), true);
    });

    // restliche Atlanten im Leerlauf vorladen, damit der Wechsel sofort sitzt
    var preload = function () {
      overlays.forEach(function (overlay) {
        var atlas = setup(overlay).config.atlas;
        Object.keys(atlas).forEach(function (key) { loadAtlas(atlas[key]); });
      });
    };
    var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 1500); };
    if (document.readyState === 'complete') {
      idle(preload);
    } else {
      window.addEventListener('load', function () { idle(preload); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
